import { motion } from "framer-motion";
import { IMG } from "./site";

const WORKS = [
  { img: IMG.kitchen, title: "Deep Kitchen Cleaning", caption: "Tile, Grout & Appliances", span: "md:col-span-7", ratio: "aspect-[16/10]" },
  { img: IMG.garage, title: "Garage Organization", caption: "Clean · Sort · Haul", span: "md:col-span-5", ratio: "aspect-[4/3] md:aspect-auto" },
  { img: IMG.tv, title: "Handyman Repairs", caption: "Installs & Fixes Done Right", span: "md:col-span-12", ratio: "aspect-[16/8]" },
];

export default function Gallery() {
  return (
    <section id="work" data-testid="gallery-section" className="relative bg-[#FDFBF7] pt-20 lg:pt-24 pb-14 lg:pb-16">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <motion.div
          initial={{ opacity: 0, y: 40 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
          className="flex flex-wrap items-end justify-between gap-6 mb-16"
        >
          <div>
            <span className="font-jet text-[11px] uppercase tracking-[0.3em] text-[#993B19]">Recent Work</span>
            <h2 className="mt-4 font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.05] text-[#0F172A]">
              Proof, Not <em className="italic text-[#D96B43]">Promises.</em>
            </h2>
          </div>
          <p className="max-w-sm text-sm text-[#64748B] leading-relaxed">
            Real jobs from real Treasure Coast homes — cleaned, fixed, mounted and hauled by the same crew, every time.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-12 gap-6">
          {WORKS.map((w, i) => (
            <motion.figure
              key={w.title}
              data-testid={`gallery-item-${i}`}
              initial={{ opacity: 0, y: 48, clipPath: "inset(8% 4% 8% 4% round 24px)" }}
              whileInView={{ opacity: 1, y: 0, clipPath: "inset(0% 0% 0% 0% round 24px)" }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 1.1, ease: [0.16, 1, 0.3, 1], delay: i * 0.12 }}
              className={`group relative overflow-hidden rounded-3xl ${w.span} ${w.ratio}`}
            >
              <img
                src={w.img}
                alt={w.title}
                loading="lazy"
                className="absolute inset-0 w-full h-full object-cover scale-105 group-hover:scale-110 transition-transform duration-[1.2s] ease-out"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0F172A]/75 via-[#0F172A]/10 to-transparent" />
              <figcaption className="absolute bottom-0 left-0 p-7">
                <span className="font-jet text-[10px] uppercase tracking-[0.25em] text-[#D96B43]">{w.caption}</span>
                <span className="block font-display text-2xl lg:text-3xl text-[#FDFBF7] tracking-tight mt-1">{w.title}</span>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
